<template>
  <footer class="ftr" :class="{ 'ftr--amari': site === 'amari' }">
    <div class="ftr__grid">
      <div class="ftr__brand">
        <SiteLogo :site="site" class="ftr__logo" />
        <p class="ftr__tag">{{ info.tagline }}</p>
      </div>

      <nav class="ftr__col" aria-label="Навигация по сайту">
        <div class="ftr__title">Разделы</div>
        <router-link v-for="item in menu" :key="item.name" :to="'/' + site + item.link" class="ftr__link">{{ item.name }}</router-link>
      </nav>

      <div class="ftr__col">
        <div class="ftr__title">Контакты</div>
        <a :href="'tel:' + info.tel" class="ftr__phone">{{ info.phone }}</a>
        <a v-if="info.tel2" :href="'tel:' + info.tel2" class="ftr__link">{{ info.phone2 }}</a>
        <p class="ftr__addr">{{ info.address }}</p>
        <a v-if="info.email" :href="'mailto:' + info.email" class="ftr__link">{{ info.email }}</a>
        <ul v-if="socials.length" class="ftr__soc">
          <li v-for="s in socials" :key="s.name">
            <a :href="s.href" target="_blank" rel="nofollow" class="ftr__soc-link" :aria-label="s.name">
              <img :src="s.icon" alt="">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="ftr__bottom">
      <span>{{ copyright }}</span>
      <router-link v-if="other" :to="'/' + other.key" class="ftr__link">{{ other.name }} {{ other.place }}</router-link>
    </div>
  </footer>
</template>

<script>
import { SITES, MENUS, siteInfo } from '../config/sites'
import { getVisibleMenu } from '../utils/photos'
import SiteLogo from './SiteLogo'
import vk from '../assets/img/footer/icon/vk.png'
import ig from '../assets/img/footer/icon/ig.png'
import fb from '../assets/img/footer/icon/fb.png'
import tg from '../assets/img/footer/icon/tg.png'
import wa from '../assets/img/footer/icon/wa.png'

export default {
  name: 'Footer',
  components: { SiteLogo },
  data () {
    return { availableMenu: [], menuLoaded: false }
  },
  computed: {
    site () {
      return this.$root.site === 'picunda' ? 'pitsunda' : this.$root.site
    },
    info () {
      return siteInfo(this.site)
    },
    other () {
      if (this.site === 'amari') return null
      return this.site === 'abaata' ? SITES.pitsunda : SITES.abaata
    },
    copyright () {
      return this.site === 'amari' ? '© Amari Hotel, Гагра' : '© Абаата ' + this.info.place
    },
    menu () {
      return this.menuLoaded ? this.availableMenu : (MENUS[this.site] || MENUS.abaata)
    },
    socials () {
      const i = this.info
      return [
        { name: 'VK', href: i.vk, icon: vk },
        { name: 'Instagram', href: i.instagram, icon: ig },
        { name: 'Facebook', href: i.facebook, icon: fb },
        { name: 'Telegram', href: i.telegram, icon: tg },
        { name: 'WhatsApp', href: i.whatsapp, icon: wa }
      ].filter(s => s.href)
    }
  },
  watch: {
    site () { this.loadMenu() }
  },
  mounted () {
    this.loadMenu()
  },
  methods: {
    loadMenu () {
      const site = this.site
      this.menuLoaded = false
      getVisibleMenu(site).then(menu => {
        if (this.site !== site) return
        this.availableMenu = menu
        this.menuLoaded = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ftr {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  background: var(--dark);
  color: var(--on-dark);
  padding: 56px var(--pad) 28px;
  font-family: var(--body);
}
.ftr__grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1.2fr;
  gap: 40px;
  max-width: var(--content-width, 1440px);
  margin: 0 auto;
}
.ftr .ftr__logo { height: 84px; color: #fff; }
.ftr .ftr__logo.logo--amari { height: 34px; margin-bottom: 14px; }
.ftr__tag { margin-top: 18px; max-width: 34ch; opacity: .75; font-size: 15px; line-height: 1.55; }
.ftr__col { display: flex; flex-direction: column; gap: 10px; align-items: flex-start; }
.ftr__title { font-size: 12px; font-weight: 700; letter-spacing: .2em; text-transform: uppercase; color: var(--acc); margin-bottom: 6px; }
.ftr__link { color: var(--on-dark) !important; opacity: .85; font-size: 15px; }
.ftr__link:hover { opacity: 1; color: #fff !important; }
.ftr__phone { color: #fff !important; font-size: 24px; font-weight: 700; }
.ftr__addr { opacity: .75; font-size: 15px; line-height: 1.5; max-width: 34ch; }
.ftr__soc { display: flex; gap: 12px; list-style: none; margin-top: 8px; padding: 0; }
.ftr__soc-link { display: block; opacity: .9; transition: opacity .2s, transform .2s; }
.ftr__soc-link:hover { opacity: 1; transform: translateY(-2px); }
.ftr__soc-link img { width: 44px; height: 44px; }
.ftr--amari {
  background: #eee7dc;
  color: #29251f;
}
.ftr--amari .ftr__logo { color: #29251f; }
.ftr--amari .ftr__title { color: #755a32; }
.ftr--amari .ftr__link { color: #29251f !important; }
.ftr--amari .ftr__link:hover { color: #755a32 !important; }
.ftr--amari .ftr__phone { color: #29251f !important; }
.ftr--amari .ftr__bottom { border-top-color: rgba(41, 37, 31, .2); }
.ftr--amari :focus-visible { outline-color: #755a32 !important; }
.ftr--amari .ftr__soc-link img { filter: brightness(0) saturate(100%) invert(34%) sepia(18%) saturate(1082%) hue-rotate(4deg) brightness(92%) contrast(87%); }
.ftr__bottom {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  max-width: var(--content-width, 1440px);
  margin: 40px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, .14);
  font-size: 13px;
  opacity: .8;
}
@media (max-width: 800px) {
  .ftr { padding-bottom: 90px; }
  .ftr__grid { grid-template-columns: 1fr; gap: 28px; }
}
</style>
